import React from "react";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import IconButton from "@mui/material/IconButton";

type PropsType = {
    readonly count: number;
    readonly onChangePage: CallableFunction;
    readonly page: number;
    readonly rowsPerPage: number;
    readonly labelDisplayedRows: any;
};

function TablePagination({
    count,
    onChangePage,
    page,
    rowsPerPage,
    labelDisplayedRows,
}: PropsType) {
    const [disableNext, setDisableNext] = React.useState<boolean>(false);
    const [disablePrev, setDisablePrev] = React.useState<boolean>(true);

    const getStart = React.useCallback(() => {
        let start = page * rowsPerPage;

        if (count !== 0) {
            start++;
        }

        return start;
    }, [page, rowsPerPage, count]);

    const getEnd = React.useCallback(() => {
        let end = getStart() - 1 + rowsPerPage;

        if (end > count) {
            end = count;
        }

        return end;
    }, [getStart, rowsPerPage, count]);

    React.useEffect(() => {
        if (getStart() === 1 || getStart() === 0) {
            setDisablePrev(true);
        } else {
            setDisablePrev(false);
        }

        if (getEnd() === count) {
            setDisableNext(true);
        } else {
            setDisableNext(false);
        }
    }, [getStart, getEnd, count]);

    return (
        <div className={"table-pagination-container"}>
            <div>
                <IconButton
                    onClick={() => {
                        onChangePage(page - 1);
                    }}
                    disabled={disablePrev}
                    aria-label={"Vai alla pagina precedente"}
                >
                    <ChevronLeftIcon titleAccess={"Vai alla pagina precedente"} />
                </IconButton>
            </div>

            <div>
                <IconButton
                    onClick={() => {
                        onChangePage(page + 1);
                    }}
                    disabled={disableNext}
                    aria-label={"Vai alla pagina successiva"}
                >
                    <ChevronRightIcon titleAccess={"Vai alla pagina successiva"} />
                </IconButton>
            </div>

            <div className={"table-pagination-label"}>
                <span>{labelDisplayedRows(getStart(), getEnd(), count)}</span>
            </div>
        </div>
    );
}

export default TablePagination;
